import { prefix } from "../../design-tokens/meta";
import { alignments } from "../../../core/js/positioning/placement";
import { events } from "../../js/state-machine";
import { matchers } from "../../js/validate-props";

export const componentName = "ActionMenu";

// Action Menu also extends events from pop passing name to it
export const eventMap = {
    open: events.open(componentName),
    close: events.close(componentName),
    selectionChange: events.selectionChange(componentName),
};

export const defaultProps = {
    alignment: alignments.start,
    closeOnScroll: true,
};

export const schema = {
    alignment: matchers.minChars(1),
    closeOnScroll: matchers.boolean,
};

export const componentClasses = {
    wrapper: `${prefix}action-menu`,
    wrapperSm: `${prefix}action-menu--sm`,
    wrapperIsPressing: `${prefix}action-menu--is-pressing`,
    container: {
        base: `${prefix}action-menu__container`,
        positioning: `${prefix}action-menu__container--positioning`,
        visible: `${prefix}action-menu__container--visible`,
    },
    menu: `${prefix}action-menu__menu`,
    separator: `${prefix}action-menu__separator`,
    item: `${prefix}action-menu__item`,
    itemDestructive: `${prefix}action-menu__item--destructive`,
    link: `${prefix}action-menu__link`,
    linkDestructive: `${prefix}action-menu__link--destructive`,
    option: `${prefix}action-menu__option`,
    check: `${prefix}action-menu__check`,
};

export const views = {
    wrapper: {
        default: { classList: [`!${componentClasses.wrapperIsPressing}`] },
        isPressing: { classList: [componentClasses.wrapperIsPressing] },
    },
    container: {
        opened: {
            attrs: { "aria-hidden": "false" },
        },
        closed: {
            attrs: { "aria-hidden": "true" },
        },
        positioning: {
            classList: [
                componentClasses.container.positioning,
                `!${componentClasses.container.visible}`,
            ],
        },
        visible: {
            classList: [
                componentClasses.container.visible,
                `!${componentClasses.container.positioning}`,
            ],
        },
        hidden: {
            classList: [
                `!${componentClasses.container.positioning}`,
                `!${componentClasses.container.visible}`,
            ],
        },
    },
    option: {
        checked: { attrs: { "aria-checked": "true" } },
        unchecked: { attrs: { "aria-checked": "false" } },
    },
};

// Constants
export const itemTypes = {
    item: "ITEM",
    link: "LINK",
    option: "OPTION",
};
